import { getConfig } from "../utils/config";
import { useEthers } from "@usedapp/core";

const useConfig = () => {
    const { chainId } = useEthers();
    return getConfig(chainId);
};

export default useConfig;
